module.exports = __webpack_public_path__ + "static/img/news.07b55ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jpg/news.jpg
// module id = 194
// module chunks = 0